// @@flow
const UPDATE_PAIRS = '@@checkout/ui/update_pairs';

const initialState = {
  isLoading: false,
  showModal: false,
  modalType: 'merchant',

  businessVisited: false,
  bankVisited: false,
  contactVisited: false,
  confirmVisited: false,

  isNotificationVisible: false,

  isFromConfirm: false,

  isBasicInfoValidated: false,
  isBusinessInfoValidated: false,
  isBankInfoValidated: false,
};

const ui = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PAIRS: {
      return {
        ...state,
        ...action.pairs,
      };
    }
    default:
      return state;
  }
};

export const updatePairs = pairs => ({
  type: UPDATE_PAIRS,
  pairs,
});

export default ui;
